
import { Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { Deals, DensityStyleTypes } from '../../../../types'

interface RenderCountProps {
  params: { row: GridRenderCellParams<Deals, object> }
  densityStyles: DensityStyleTypes
}

const RenderCountCell: React.FC<RenderCountProps> = ({ params, densityStyles }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {<Typography sx={{ fontSize: 14, textAlign: 'center' }}>{(params as any)?.value}</Typography>}
    </Box>
  )
}
export default RenderCountCell
